<template>
    <div>
        <NavBar></NavBar>
        <h3 class="mt-2">Linea de Perfiles</h3>
        <h7
      >Seleccione el grupo de formas que corresponda para su perfil.</h7
    >
    <ul>
      <li><router-link to="/ProfileQuote"> Grupo 1 - Formas Tipo Perfil "I"</router-link></li>
      <li>Grupo 2 - Formas Tipo Perfil canal "U"</li>
      <li>Grupo 3 - Formas Tipo Perfil "H"</li>
      <li>Grupo 4 - Formas Tipo Perfil Ángulo</li>
    </ul>
    </div>
</template>
<script>
import NavBar from "@/components/GeneralComponents/NavBarComponent.vue";
export default {
  data() {
    return {

    };
  },
  methods:{

  },
  components:{
    NavBar,
  },
};

</script>
<style scoped>
</style>
